export default "__VITE_ASSET__3a16ff22__"